import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Navigation from "./components/Layout/Navigation/Navigation";
import Homepage from "../src/Pages/Homepage/Homepage";
import Bio from "../src/Pages/Bio/Bio";
import News from "../src/Pages/News/News";
import Schedule from "../src/Pages/Schedule/Schedule";
import Partners from "../src/Pages/Partners/Partners";
import DriversPage from "../src/Pages/DriversPage/DriversPage";
import Sponsorships from "../src/Pages/Sponsorships/Sponsorships";
import Contact from "../src/Pages/Contact/Contact";
import Shop from "../src/Pages/Shop/Shop";

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Navigation />
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/Bio" element={<Bio />} />
          <Route path="/News" element={<News />} />
          <Route path="/Schedule" element={<Schedule />} />
          <Route path="/Partners" element={<Partners />} />
          <Route path="/DriversPage" element={<DriversPage />} />
          <Route path="/Sponsorships" element={<Sponsorships />} />
          <Route path="/Contact" element={<Contact />} />
          <Route path="/Shop" element={<Shop />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
